// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// GraphQL
import UpdateRegistration from '@/graphql/registrations/update/updateRegistration.gql';
import InsertRegistrations from '@/graphql/registrations/insert/insertRegistrations.gql';
import DeleteRegistration from '@/graphql/registrations/delete/deleteRegistration.gql';

export default {
	state: {
		registrations: [] as Registration[],
	},

	// ================ Getters ================
	getters: {
		registrations(state: any) {
			return state.registrations;
		},
	},

	// ================ Mutations ================
	mutations: {
		setRegistrations(state: any, registrations: any) {
			state.registrations = registrations;
		},
	},

	// ================= Actions =================
	actions: {
		async getRegistrations({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query registrations {
						registrations {
							id
							display_name
							location: locationByLocation {
								id
								name
								city {
									id
									name
								}
							}
							player_type
							team_size
							day_of_week
							status
							number_of_places
							type
							players: registrations_players {
								playerByPlayer {
									id
									first_name
									last_name
								}
							}
							teams: registrations_teams {
								teamByTeam {
									id
									name
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			const { registrations } = response.data;
			commit('setRegistrations', registrations);
		},

		async insertRegistration({ dispatch }: any, payload: Registration) {
			const objects = [payload];

			await apolloClient
				.mutate({
					mutation: InsertRegistrations,
					// Parameters
					variables: {
						objects,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			await dispatch('getRegistrations');
			return;
		},

		async deleteRegistration({ dispatch }: any, payload: any) {
			const { id } = payload;
			await apolloClient
				.mutate({
					mutation: DeleteRegistration,
					// Parameters
					variables: {
						countryId: id,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getRegistrations');
			return;
		},

		async updateRegistration({ dispatch }: any, payload: any) {
			const { id, name } = payload;
			await apolloClient.mutate({
				mutation: UpdateRegistration,
				// Parameters
				variables: {
					countryId: id,
					name,
				},
			});

			dispatch('getRegistrations');
			return;
		},
	},
};
